import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Loader from "Common/Loader";
import { HttpStatus, SelectListItem } from "modules/core";
import notistack from "modules/core/notistack";
import { getAllStoreForSelect } from "modules/store/StoreMaster/services";
import { UserDetailsModel } from "../models";
import { getAllUserRoles } from "modules/user-management/user-master-role/services";
import { updateUser } from "../services";

interface UserDetailsModelProps {
  userDetails: UserDetailsModel;
  closeModal: () => void;
  onUpdateSucess: () => void;
}


const UpdateUserModal = ({ userDetails, closeModal, onUpdateSucess }: UserDetailsModelProps) => {
  const [loading, setLoading] = useState(false);
  const [storeDataList, setStoreData] = useState<SelectListItem[]>([]);
  const [roleDataList, setRoleData] = useState<SelectListItem[]>([]);
  const [showUserMasterUpdateModal, setShowUserMasterUpdateModal] = useState(false);

  const { register, handleSubmit, formState: { errors }, reset, } = useForm({ mode: "onChange" });

  useEffect(() => {
    // Fetch store and role data when the component mounts
    getAllStoreDetails();
    getAllRoleDetails();
  }, []);

  const getAllStoreDetails = async () => {
    try {
      const response = await getAllStoreForSelect();
      if (response.status === HttpStatus.Success) {
        setStoreData(response.data);
      } else {
        // notistack.notifyFromApi(response);
      }
    } catch (error) {
      // console.error("Error fetching store details:", error);
    }
  };

  const getAllRoleDetails = async () => {
    try {
      const response = await getAllUserRoles();
      if (response.status === HttpStatus.Success) {
        setRoleData(response.data);
      } else {
        // notistack.notifyFromApi(response);
      }
    } catch (error) {
      // console.error("Error fetching role details:", error);
    }
  };

  const onSubmit = async (data: any) => {
    try {
      setLoading(true);
      const model = UserDetailsModel.setUserData(data);
      const response = await updateUser(model);
      if (response.status === HttpStatus.Success) {
        // notistack.notifyFromApi(response);
        onUpdateSucess();
        setShowUserMasterUpdateModal(false);
        reset(); // Reset the form fields after successful submission
      } else {
        // notistack.notifyFromApi(response);
      }
    } catch (error) {
      // console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && <Loader />}
      <form onSubmit={onSubmit}>
        <div className="row">
          <div className="col-sm-3">
            <label>
              Name:<span style={{ color: "red" }}>*</span>
            </label>
            <input className="form-control" type="text" />
          </div>

          <div className="col-sm-3">
            <label>
              Email:<span style={{ color: "red" }}>*</span>
            </label>
            <input className="form-control" type="email" />
          </div>

          <div className="col-sm-3">
            <label>
              Mobile Number:<span style={{ color: "red" }}>*</span>
            </label>
            <input className="form-control" type="tel" onKeyDown={(e) => {
              if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                e.preventDefault();
              }
            }} />
          </div>

          <div className="col-sm-3">
            <label>
              User Name:<span style={{ color: "red" }}>*</span>
            </label>
            <input className="form-control" type="text" />
          </div>

          <div className="col-sm-3">
            <label>
              Password:<span style={{ color: "red" }}>*</span>
            </label>
            <input className="form-control" type="password" />
          </div>

          <div className="col-sm-3">
            <label>Role:</label>
            <select className="form-control">
              <option value="">-- Role --</option>
            </select>
          </div>

          <div className="col-sm-3">
            <label>Store:</label>
            <select className="form-control">
              <option value="">-- Store --</option>
            </select>
          </div>

          <div className="col-sm-3">
            <label>Remark:</label>
            <input className="form-control" type="text" />
          </div>
        </div>

        <div className="d-flex justify-content-end  align-items-end mt-4">
          <button
            type="button"
            className="btn btn-danger me-1"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary">
            Save
          </button>
        </div>
      </form>
    </>
  )
}

export default UpdateUserModal